// extracted by mini-css-extract-plugin
export var closeIcon = "NotificationsContext-module--closeIcon--8b16c";
export var notification = "NotificationsContext-module--notification--29bd6";
export var notificationContainer = "NotificationsContext-module--notificationContainer--f152e";
export var notificationIcon = "NotificationsContext-module--notificationIcon--68cfc";